module.exports = __webpack_public_path__ + "img/1.3d84f588.png";